"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlusIcon = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PlusIcon = function PlusIcon(props) {
  return _react["default"].createElement("svg", {
    fill: props.color,
    height: "".concat(props.size || 39),
    width: "".concat(props.size || 39),
    viewBox: '0 0 24 24'
  }, _react["default"].createElement("g", null, _react["default"].createElement("path", {
    stroke: props.color,
    strokeWidth: 2,
    d: "M12 5.5v13"
  }), _react["default"].createElement("path", {
    stroke: props.color,
    strokeWidth: 2,
    d: "M18.5 12h-13"
  })));
};

exports.PlusIcon = PlusIcon;